import * as React from "react";
import Avatar from "./VideoVisitV2/components/Avatar";

function GuestAllowDenyModal({userName, onAllowClick, onDenyClick, showModal}){
    return (showModal ?
        <div className="guest-deny-allow-modal">
            <div>
                <Avatar userName={userName} />
                <div className="modal-text"><span className="name">{userName}</span> wants to join this room.</div>
                <div className="links-container">
                    <button className="btn btn-link-style" onClick={onDenyClick}>Deny</button>
                    <button className="btn btn-link-style" onClick={onAllowClick}>Allow</button>
                </div>
            </div>
        </div> : null
    );
}

export default GuestAllowDenyModal;